// extracted by mini-css-extract-plugin
export var leftContent = "simple-text-module--leftContent--03bfc";
export var simpleText = "simple-text-module--simpleText--f2b88";
export var simpleTextBlock = "simple-text-module--simpleTextBlock--2ffa7";